<template>
  <div class="sales-statistics flex-column mb-2 pb-2">
    <div class="d-flex">
      <div class="d-flex p-0 align-items-start">
        <span class="statistics-heading">
          Statistics for {{ meta.total }} Sales representatives
        </span>
      </div>
    </div>
    <div class="flex-column">
      <div class="d-flex">
        <div class="d-flex p-0 col-1">
          <span class="statistics-heading">
            <span />
          </span>
        </div>
        <div class="d-flex flex-wrap p-0 col-11">
          <div class="d-flex col-12 p-0 text-uppercase text-center">
            <div class="col-1 p-0 d-flex justify-content-end category-value">
              <span />
            </div>
            <div class="statistics-heading flex-even p-0">
              Total
            </div>
            <div class="statistics-heading flex-even p-0">
              Phone
            </div>
            <div class="statistics-heading flex-even p-0">
              Website
            </div>
            <div class="statistics-heading flex-even p-0">
              Yelp Chat
            </div>
            <div class="statistics-heading flex-even p-0">
              No Availability
            </div>
            <div class="statistics-heading col-1 p-0">
              Mod24
            </div>
            <div class="statistics-heading col-3 p-0">
              Conversion
            </div>
          </div>
          <div class="d-flex col-12 p-0">
            <div class="col-1 p-0 d-flex justify-content-end category-value">
              <span />
            </div>
            <div class="flex-even p-0 d-flex justify-content-start category-value">
              <div class="category-value col-6 p-0">
                Books
              </div>
              <div class="category-value col-6 p-0">
                Leads
              </div>
            </div>
            <div class="flex-even p-0 d-flex justify-content-start category-value">
              <div class="category-value col-6 p-0">
                Books
              </div>
              <div class="category-value col-6 p-0">
                Leads
              </div>
            </div>
            <div class="flex-even p-0 d-flex justify-content-start category-value">
              <div class="category-value col-6 p-0">
                Books
              </div>
              <div class="category-value col-6 p-0">
                Leads
              </div>
            </div>
            <div class="flex-even p-0 d-flex justify-content-start category-value">
              <div class="category-value col-6 p-0">
                Books
              </div>
              <div class="category-value col-6 p-0">
                Leads
              </div>
            </div>
            <div class="flex-even p-0 d-flex justify-content-start category-value">
              <div class="category-value col-6 p-0">
                All
              </div>
              <div class="category-value col-6 p-0">
                Website
              </div>
            </div>
            <div class="col-1 p-0 d-flex justify-content-start category-value">
              Books
            </div>
            <div class="col-3 p-0 d-flex justify-content-start category-value">
              <div class="category-value col-4 p-0">
                Total
              </div>
              <div class="category-value col-4 p-0">
                Phone
              </div>
              <div class="category-value col-4 p-0">
                Website
              </div>
            </div>
          </div>
          <div class="d-flex col-12 p-0">
            <div class="col-1 p-0 d-flex justify-content-end category-value">
              <span class="text-left pr-4">
                Total
              </span>
            </div>
            <div class="flex-even p-0 d-flex justify-content-start category-value">
              <div class="category-value col-6 p-0">
                {{ sums.total_jobs }}
              </div>
              <div class="category-value col-6 p-0">
                {{ sums.total_leads }}
              </div>
            </div>
            <div class="flex-even p-0 d-flex justify-content-start category-value">
              <div class="category-value col-6 p-0">
                {{ sums.phone_jobs }}
              </div>
              <div class="category-value col-6 p-0">
                {{ sums.phone_leads }}
              </div>
            </div>
            <div class="flex-even p-0 d-flex justify-content-start category-value">
              <div class="category-value col-6 p-0">
                {{ sums.website_jobs }}
              </div>
              <div class="category-value col-6 p-0">
                {{ sums.website_leads }}
              </div>
            </div>
            <div class="flex-even p-0 d-flex justify-content-start category-value">
              <div class="category-value col-6 p-0">
                {{ sums.yelp_chat_jobs }}
              </div>
              <div class="category-value col-6 p-0">
                {{ sums.yelp_chat_leads }}
              </div>
            </div>
            <div class="flex-even p-0 d-flex justify-content-start category-value">
              <div class="category-value col-6 p-0">
                {{ sums.no_availability_all }}
              </div>
              <div class="category-value col-6 p-0">
                {{ sums.no_availability_website }}
              </div>
            </div>
            <div class="col-1 p-0 d-flex justify-content-start category-value">
              {{ sums.mod_jobs }}
            </div>
            <div class="col-3 p-0 d-flex justify-content-start category-value">
              <div class="category-value col-4 p-0">
                {{ sums.conversion_total }}
              </div>
              <div class="category-value col-4 p-0">
                {{ sums.conversion_phone }}
              </div>
              <div class="category-value col-4 p-0">
                {{ sums.conversion_website }}
              </div>
            </div>
          </div>
          <div class="d-flex col-12 p-0">
            <div class="col-1 p-0 d-flex justify-content-end category-value">
              <span class="text-left pr-4">
                Average
              </span>
            </div>
            <div class="flex-even p-0 d-flex justify-content-start category-value">
              <div class="category-value col-6 p-0">
                {{ averages.total_jobs }}
              </div>
              <div class="category-value col-6 p-0">
                {{ averages.total_leads }}
              </div>
            </div>
            <div class="flex-even p-0 d-flex justify-content-start category-value">
              <div class="category-value col-6 p-0">
                {{ averages.phone_jobs }}
              </div>
              <div class="category-value col-6 p-0">
                {{ averages.phone_leads }}
              </div>
            </div>
            <div class="flex-even p-0 d-flex justify-content-start category-value">
              <div class="category-value col-6 p-0">
                {{ averages.website_jobs }}
              </div>
              <div class="category-value col-6 p-0">
                {{ averages.website_leads }}
              </div>
            </div>
            <div class="flex-even p-0 d-flex justify-content-start category-value">
              <div class="category-value col-6 p-0">
                {{ averages.yelp_chat_jobs }}
              </div>
              <div class="category-value col-6 p-0">
                {{ averages.yelp_chat_leads }}
              </div>
            </div>
            <div class="flex-even p-0 d-flex justify-content-start category-value">
              <div class="category-value col-6 p-0">
                {{ averages.no_availability_all }}
              </div>
              <div class="category-value col-6 p-0">
                {{ averages.no_availability_website }}
              </div>
            </div>
            <div class="col-1 p-0 d-flex justify-content-start category-value">
              {{ averages.mod_jobs }}
            </div>
            <div class="col-3 p-0 d-flex justify-content-start category-value">
              <div class="category-value col-4 p-0">
                {{ averages.conversion_total }}
              </div>
              <div class="category-value col-4 p-0">
                {{ averages.conversion_phone }}
              </div>
              <div class="category-value col-4 p-0">
                {{ averages.conversion_website }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SalesTotalsStatistics',
  props: {
    meta: {
      type: Object,
      default: () => {},
    },
    sums: {
      type: Object,
      default: () => {},
    },
    averages: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
.sales-statistics {
  display: flex;
  background: #3f4247;
  box-shadow: 0 2px 0 rgba(33, 37, 41, 0.0263604);
  border-radius: 2px;
  justify-content: space-between;
}
.statistics {
  padding-right: 21px;
}
.fee {
  padding-right: 20px;
}
.statistics-heading {
  padding: 12px 0 0 12px;
  color: white;
  font-weight: 500;
  font-size: 12px;
}
.statistic-name {
  color: white;
  font-weight: 500;
  font-size: 10px;
  display: flex;
  align-items: center;
}
.statistic-wrap {
  max-height: 30px;
}
.category-name {
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  padding-top: 6px;
}
.category-value {
  color: white;
  font-weight: 500;
  font-size: 12px;
  display: flex;
  align-items: center;
}
.avg-value {
  color: white;
  font-weight: 500;
  font-size: 10px;
  display: flex;
  align-items: center;
}
.spacing {
  margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/sales/SalesTotalsStatistics.vue